import moment from 'moment';
import React, { useState } from 'react';

import saveAs from 'file-saver';
import Modal from 'react-modal';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';

import {
  toWeekInt,
  toWeekStartDate,
  toWeekString,
} from '../../../../../helpers/moment';
const { API_URL } = config;

const WeekNav = ({
  activeDate,
  activeWeek,
  activeClient,
  activeSite,
  week,
  totalShifts,
  totalFillRate,
  totalAttendanceRate,
  title,
  today,
  prev,
  next,
  siteAssociateLeaves,
  setSidebarMultiAssocLeaves,
}) => {
  const type = localStorage.getItem('type');
  const token = localStorage.getItem('token');

  const padding = 90; // adjust this to your needs
  let height = 300 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const [email, setEmail] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showWeeklyModal, setShowWeeklyModal] = useState(false);
  const [showDailyModal, setShowDailyModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleOpenWeeklyModal = () => setShowWeeklyModal(true);
  const handleCloseWeeklyModal = () => setShowWeeklyModal(false);
  const handleOpenDailyModal = () => setShowDailyModal(true);
  const handleCloseDailyModal = () => setShowDailyModal(false);

  const downloadAttendanceDailyHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_schedule_daily`;
    const date = activeDate;
    const filename = `Attendance-day-${activeDate}.xlsx`;
    await downloadHandler(url, date, filename);
  };

  const downloadAttendanceWeeklyHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_schedule`;
    const start_date = moment(activeWeek.startDate).format('YYYY-MM-DD');
    const end_date = moment(activeWeek.startDate, 'YYYY-MM-DD')
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const filename = `Attendance-week${week}-${start_date}-${end_date}.xlsx`;
    await downloadHandler(url, start_date, filename);
  };

  const downloadPreferredShiftHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_preferred_shift`;
    const start_date = moment(activeWeek.startDate).format('YYYY-MM-DD');
    const end_date = moment(activeWeek.startDate, 'YYYY-MM-DD')
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const filename = `Preferred-week${week}-${start_date}-${end_date}.xlsx`;
    await downloadHandler(url, start_date, filename);
  };

  const downloadPreferredShiftDailyHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_preferred_shift_daily`;
    const date = activeDate;
    const filename = `Preferred-day-${date}.xlsx`;
    await downloadHandler(url, date, filename);
  };

  const downloadWeeklyOlloHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_weekly_ollo`;
    const start_date = moment(activeWeek.startDate).format('YYYY-MM-DD');
    const end_date = moment(activeWeek.startDate, 'YYYY-MM-DD')
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const filename = `Attendance-week${week}-${start_date}-${end_date}.xlsx`;
    await downloadHandler(url, start_date, filename);
  };

  const downloadDailyOlloHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_daily_ollo`;
    const date = activeDate;
    const filename = `Attendance-day-${date}.xlsx`;
    await downloadHandler(url, date, filename);
  };

  const downloadWeeklyIkanoHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_weekly_ikano`;
    const start_date = moment(activeWeek.startDate).format('YYYY-MM-DD');
    const end_date = moment(activeWeek.startDate, 'YYYY-MM-DD')
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const filename = `Ikano-Attendance-week${week}-${start_date}-${end_date}.xlsx`;
    await downloadHandler(url, start_date, filename);
  };

  const downloadWeeklyDeploymentHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_weekly_deployment`;
    const start_date = moment(activeWeek.startDate).format('YYYY-MM-DD');
    const end_date = moment(activeWeek.startDate, 'YYYY-MM-DD')
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const filename = `Deployment-week${week}-${start_date}-${end_date}.xlsx`;
    await downloadHandler(url, start_date, filename);
  };

  const downloadDailyIkanoHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_daily_ikano`;
    const date = activeDate;
    const filename = `Ikano-Attendance-day${date}.xlsx`;
    await downloadHandler(url, date, filename);
  };

  const downloadHandler = async (url, start_date, filename) => {
    try {
      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          start_date: start_date,
        }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let responseData = await response.json();
      if (response.ok && responseData.data.buffer !== undefined) {
        const buffer = responseData.data.buffer.data;
        const arraybuffer = Uint8Array.from(buffer).buffer;

        const blob = new Blob([arraybuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, filename);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const emailHandler = async () => {
    let url = `${API_URL}/site/${activeSite.id}/master_schedule/mail`;

    try {
      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
          email: email,
          week: week,
        }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        ToastUtil.success('Master Schedule sent to email successfully.');
        handleCloseModal();
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      <div className="d-flex align-items-end">
        <div style={{ width: '225px' }}>
          <div className="pb-1 fw-medium text-muted">Week {week}</div>
          <h6 style={{ fontSize: '1rem' }}>{title}</h6>
        </div>
        <div className="pb-1">
          <button
            className="btn btn-light text-dark border bg-white prevNextWeekNav"
            onClick={() => prev()}
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            className="btn btn-light text-dark border bg-white prevNextWeekNav"
            onClick={() => today()}
          >
            <i className="far fa-circle"></i>
          </button>
          <button
            className="btn btn-light text-dark border bg-white prevNextWeekNav"
            onClick={() => next()}
            disabled={
              type === 'client' && moment(activeWeek.endDate).isAfter(moment())
            }
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
        <div className="ms-auto d-flex flex-row align-items-center justify-content-between py-2">
          {/* <div className="me-4">
            <span className="fs-6 fw-medium">Total Leaves:</span>{' '}
            {siteAssociateLeaves.length > 0 ? (
              <Link to="#" onClick={() => setSidebarMultiAssocLeaves(true)}>
                <span className="total-style">
                  {siteAssociateLeaves.length}
                </span>
              </Link>
            ) : (
              <span className="total-style">{siteAssociateLeaves.length}</span>
            )}
          </div> */}
          <div className="me-4">
            <span className="fs-6 fw-medium">Total Slots:</span>{' '}
            <span className="total-style">{totalShifts}</span>
          </div>
          {toWeekStartDate(moment(activeDate), activeClient.start_day) <
          toWeekStartDate(moment(), activeClient.start_day) ? (
            <div className="me-4">
              <span className="fs-6 fw-medium">Total Attendance Rate:</span>{' '}
              <span className="total-style">
                {totalAttendanceRate.rate ? totalAttendanceRate.rate : 0}%
              </span>
            </div>
          ) : (
            <div className="me-4">
              <span className="fs-6 fw-medium">Total Fill Rate:</span>{' '}
              <span className="total-style">
                {totalFillRate ? totalFillRate : 0}%
              </span>
            </div>
          )}

          {activeSite.enable_dl_weekly_reports ? (
            <div className="d-flex justify-content-between align-items-baseline dropdown custom-dropdown">
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-outline-brand dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Reports
                </button>
                <div
                  className="dropdown-menu dropdown-menu-right mt-2"
                  style={{ width: '100px' }}
                  aria-labelledby="dropdownMenuButton"
                >
                  <span
                    onClick={handleOpenWeeklyModal}
                    className="dropdown-item"
                    style={{ cursor: 'pointer' }}
                  >
                    Weekly
                  </span>
                  <span
                    onClick={handleOpenDailyModal}
                    className="dropdown-item"
                    style={{ cursor: 'pointer' }}
                  >
                    Daily
                  </span>
                </div>
              </React.Fragment>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <h5>Send Master Schedule</h5>
          <small>
            Enter email to send master schedule for Week{' '}
            {toWeekInt(activeWeek.startDate, activeClient.start_day)},{' '}
            {toWeekString(activeWeek.endDate, activeClient.start_day)}
          </small>
          <input
            type="text"
            className="form-control mt-4"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="py-4 border-top d-flex justify-content-end mt-auto">
            <button
              className="btn btn-outline-default"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button className="btn btn-brand" onClick={emailHandler}>
              Send
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={showWeeklyModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <h4>Download a weekly reports for {activeSite && activeSite.name}</h4>
          <h3 style={{ color: 'gray', marginLeft: 10 }}>
            [Week {week}] {title}
          </h3>
          <div className="">
            <ul className="unstyled">
              <li key="3">
                <a href="#" onClick={downloadWeeklyOlloHandler}>
                  Attendance Report - Template
                </a>
              </li>
            </ul>
          </div>
          <div className="py-4 border-top d-flex justify-content-end mt-auto">
            <button
              className="btn btn-outline-brand"
              onClick={handleCloseWeeklyModal}
              style={{ paddingLeft: 20, paddingRight: 20 }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={showDailyModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <h3 style={{ color: 'gray', marginLeft: 10 }}>
            [{activeSite && activeSite.name}]Daily Reports:{' '}
            {moment(activeDate).format('MMM DD')}
          </h3>
          <div className="">
            <ul className="unstyled">
              <li key="3">
                <a href="#" onClick={downloadDailyOlloHandler}>
                  Attendance Report - Template
                </a>
              </li>
            </ul>
          </div>
          <div className="py-4 border-top d-flex justify-content-end mt-auto">
            <button
              className="btn btn-outline-brand"
              onClick={handleCloseDailyModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default WeekNav;
